
/**
 *      Data-driven UI that displays data in the single record details page
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 07/21/2017
 *      Modified on 06/12/2018
 */


/**
 * Display JSON data model in the single record page
 * @param response {object} - ES response object
 * @param viewModel {Backbone.Model} - page view model
 * @param names  {[string]} - data section names from API model
 * @param urls {[string]} - array of data URLs
 */
function displayDetailsPage( response, viewModel, names, urls ) {
    var type,
        model;
    if ( GlobalPageState ) {
        // Get the type of data to request
        type = GlobalPageState.type;
        if ( type ) {
            // check if the UI model exists in the global store
            model = getDataModel( type, false );

            if ( model ) {
                displayResponse( response, viewModel, names, model, urls );
            } else {
                // Fetch the model
                // If call to DMR fails, log the error
                getJSONUIModel( type, displayServerJSONModel( response, viewModel, names, type, urls ), dataNotFound( "DMR URL for " + type ));
            }
        }
    }
}

/**
 * Create and render default layout view for a single record page
 * @param model {Object} - view model to render
 * @param jsonModel {object} - data JSON model
 * @param data {Object} - record data object
 */
function displayDefaultDataObject( model, jsonModel, data ) {
    var response,
        key,
        total,
        extraData = getExtraData( model, data);

    // Nested region view or a view of multiple objects
    if ( hasKeys( data ) ) {
        for ( key in data ) {
            if ( data.hasOwnProperty( key )) {
                // extraData object is the data that is not needed in the view but is included in the data object
                if ( ! ( extraData && extraData.hasOwnProperty( key ) ) ) {
                    response = getResponseObject( data[ key ] );
                    total = getNumberOfHits( data[ key ] );
                    parseDefaultDataSource( response, model, jsonModel, total );
                }
            }
        }
    }
}

/**
 * Parse data _source object based on the region default view (parse all fields)
 * @param response {object} - ES response object
 * @param layoutModel {object} - region view model
 * @param jsonModel {object} - data JSON model
 * @param total {number} - number greater than or equal to zero
 */
function parseDefaultDataSource( response, layoutModel, jsonModel, total ) {

    var recordCollection,
        type;
    if ( layoutModel ) {
        // Default layout is the dynamically model-driven layout that follows the layout of the DMR model
        if ( layoutModel.default && layoutModel.default.toString() === "true" ) {
            // Create a table of linked records
            if ( layoutModel.table && layoutModel.table.toString() === "true" ) {
                createLinkedTable( response, layoutModel, total );
            } else {
                // Display data in dynamically generated panels
                if ( jsonModel ) {
                    // Convert JSON model into a Backbone.Collection
                    recordCollection = getBackboneCollection( jsonModel.properties );
                    if ( recordCollection ) {
                        // Get the first object out of search response because it is should always be one record
                        if ( response && response.length === 1 ) {
                            // Check that the type of the model matches the type of record to avoid duplicate rendering
                            if (jsonModel && jsonModel.properties && jsonModel.properties.length > 0) {
                                type = jsonModel.properties[0].name;
                                if ( type && type === response[0]._type ) {
                                    createRegionElements( layoutModel, jsonModel, response[0], "top-record" );
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Parse the layout model and create nested DOM regions where data will be rendered
 * @param layoutModel {object} - region view model
 * @param jsonModel {object} - data JSON model
 * @param response {object} - ES response object
 * @param topId {string} - top-level ID
 */
function createRegionElements( layoutModel, jsonModel, response, topId ) {

    var layoutId,
        properties,
        el,
        defaultLayout,
        newModel,
        title,
        parentId,
        panelBodyId,
        panelItemsId;

    // Loop over the data model and create nested regions, one for each "object" type field
    if ( layoutModel && layoutModel.template ) {
        layoutId = layoutModel.template.substr(1);

        if ( layoutId ) {

            // create top-level panel for all fields inside properties array
            el = document.createElement("div");
            el.id = topId;
            addDOMElement( el, layoutId);

            // Add top-level layout

            defaultLayout = getDefaultLayout( layoutModel );

            if ( defaultLayout ) {
                // create panel for general top level fields

                if ( jsonModel && jsonModel.properties ) {
                    if ( jsonModel.properties.length === 1 ) {
                        properties = jsonModel.properties[ 0 ];

                        if ( properties ) {
                            title = properties.label;
                            parentId = properties.name;
                            panelBodyId = parentId + "-body";
                            panelItemsId = parentId + "-primitive";

                            if ( properties.properties) {
                                newModel = { "properties": properties.properties };

                                // add nested panel element
                                createNestedPanels( defaultLayout, el.id, title, parentId, panelBodyId, panelItemsId );

                                // create nested regions for every "object" type field
                                createNestedRegions( newModel.properties, panelBodyId, layoutModel, newModel, defaultLayout, response, 0 );

                                // remove unnecessary empty messages from nested panels
                                cleanupEmptyViews( el.id );
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Hide empty view message from panels that have children. Only the lowest child will display an empty message.
 * @param topId {string} - DOM element id attribute of the top-level panel
 */
function cleanupEmptyViews( topId ) {

    var panels,
        panel,
        children,
        emptyViews,
        parentView,
        currentEmptyView,
        maxId,
        i,
        j;

    if ( topId ) {
        panels = $('#' + topId).children('.panel-default');

        // the first child of the top panel is the default panel which contains all other nested panels

        if ( panels && panels.length === 1 ) {
            panel = panels[ 0 ];
            children = $( panel ).find( '.panel-default' );

            if ( children ) {

                for ( i = 0; i < children.length; i++ ) {
                    emptyViews = $( children[ i ] ).find( '.empty-view' );

                    if ( emptyViews && emptyViews.length > 1 ) {
                        // remove empty message from higher level panels
                        parentView = $( emptyViews[ 0 ] );
                        if ( parentView ) {

                            maxId = parentView.attr( "id" );
                            for ( j = 0; j < emptyViews.length; j++ ) {

                                currentEmptyView = $( emptyViews[ j ] );

                                if ( currentEmptyView && Number( currentEmptyView.attr( "id" ) ) > Number( maxId ) ) {
                                    parentView.hide();
                                    parentView = currentEmptyView;
                                    maxId = currentEmptyView.attr( "id" );

                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Get a new instance of the single record default layout
 * @param layoutModel {object} - region view model
 * @returns {*}
 */
function getDefaultLayout( layoutModel ) {
    var viewJSON,
        DefaultLayout,
        result;

    if ( GlobalPageState ) {
        viewJSON = getJSONModel( "view", GlobalPageState.type, null );
        if ( viewJSON && viewJSON.properties && viewJSON.properties.length === 1 ) {

            DefaultLayout = Backbone.Marionette.LayoutView.extend({
                template: viewJSON.properties[0].template
            });

            if ( layoutModel && layoutModel.template ) {
                result = new DefaultLayout({ el: layoutModel.template });
            }
        }
    }
    return result;
}

/**
 * Create nested regions in the DOM  for nested field objects
 * @param properties {[object]} - array of field objects
 * @param el {string} - parent element DOM id value
 * @param layoutModel {object} - region view model
 * @param jsonModel {object} - data JSON model
 * @param defaultLayout {object} - top-level Backbone.Marionette.LayoutView object
 * @param response {object} - ES response object
 * @param level {number} - level of the nested properties (top level is 0)
 */
function createNestedRegions( properties, el, layoutModel, jsonModel, defaultLayout, response, level ) {

    var collectionObject = {},
        collection = [],
        field,
        parentId,
        title,
        panelBodyId,
        panelItemsId,
        i;
    if ( properties && properties.length ) {

        for ( i = 0; i < properties.length; i++ ) {
            field = properties[i];
            if ( field && field.name && field.type === "object" ) {

                parentId = field.name;
                title = field.label;
                panelBodyId = parentId + "-body";
                panelItemsId = parentId + "-primitive";

                // add nested parent element
                createNestedPanels( defaultLayout, el, title, parentId, panelBodyId, panelItemsId );
                createNestedRegions( field.properties, panelBodyId, layoutModel, jsonModel, defaultLayout, response, level + 1 );
            } else {
                // create a collection of primitive fields
                collection.push( field );
            }
        }
    }
    if ( collection.length > 0) {
        collectionObject[ el ] = collection;
        // display primitive fields inside their parent regions
        displayPrimitiveFields( defaultLayout, layoutModel, jsonModel, collectionObject, response, level );
    }
}

/**
 * Add DOM elements for the panel with title and body for non-nested items
 * @param defaultLayout {object} - top-level Backbone.Marionette.LayoutView object
 * @param elId {string} - parent element DOM id value
 * @param title {string} - panel header title
 * @param parentId {string} - panel DOM id value
 * @param panelBodyId {string} - panel body DOM id value
 * @param panelItemsId {string} - panel items DOM id value
 */
function createNestedPanels( defaultLayout, elId, title, parentId, panelBodyId, panelItemsId ) {

    var parentDiv,
        panelHeader,
        panelHeaderId,
        panelTitle,
        panelBody,
        div;

    // Add nested parent element
    parentDiv = document.createElement("div");

    parentDiv.setAttribute( "id", parentId );
    parentDiv.setAttribute( "class", "panel panel-default" );
    addDOMElement( parentDiv, elId );

    // add panel header

    panelHeader = document.createElement("div");
    panelHeaderId = parentId + "-header";
    panelHeader.setAttribute( "id", panelHeaderId );
    panelHeader.setAttribute( "class", "panel-heading" );
    addDOMElement( panelHeader, parentId );

    // add panel title

    panelTitle = document.createElement("h4");
    panelTitle.setAttribute("class", "panel-title");
    $( panelTitle ).text( title );
    addDOMElement( panelTitle, panelHeaderId );

    // add panel body

    panelBody = document.createElement("div");
    panelBody.setAttribute( "id", panelBodyId );
    panelBody.setAttribute( "class", "panel-body" );
    addDOMElement( panelBody, parentId );

    // add element for primitive fields to the parent element

    div = document.createElement('div');
    div.id = panelItemsId;
    addDOMElement( div, panelBodyId );

    // Add regions to the layout
    defaultLayout.addRegion( parentId, '#' + parentId );
    defaultLayout.addRegion( panelItemsId, '#' + panelItemsId );
}

/**
 * Display a collection of primitive fields
 * @param defaultLayout {object} - instance of Backbone.Marionette.LayoutView
 * @param layoutModel {object} - region view model
 * @param jsonModel {object} - {object} - data JSON model
 * @param collection {object} - object with key as the nested field name and value as an array of nested field properties
 * @param response {object}  - ES response object
 * @param level {number} - level of the nested properties (top level is 0)
 */
function displayPrimitiveFields( defaultLayout, layoutModel, jsonModel, collection, response, level ) {

    var childObject,
        backboneCollection,
        updatedCollection,
        key,
        source,
        fieldModel,
        collectionArray,
        i;

    if ( layoutModel && defaultLayout ) {

        updatedCollection = updateCollectionWithValues( jsonModel, collection, response, level );

        if ( hasKeys ( updatedCollection )) {
            for ( key in updatedCollection ) {
                if ( updatedCollection.hasOwnProperty(key)) {

                    if ( response ) {
                        source = response["_source"];
                        fieldModel = getFieldModel( key.replace("-body", ""), jsonModel, level, source );

                        if ( fieldModel && fieldModel.multiple && fieldModel.multiple.toString() === "true" ) {
                            childObject = layoutModel.model.childViewMultiple;

                            collectionArray = updatedCollection [ key ];
                            backboneCollection = new BackboneCollection();

                            for (i = 0; i < collectionArray.length; i++ ) {
                                // check that the array inside the collection is not empty
                                if ( collectionArray[i] && collectionArray[i].length > 0 ) {
                                    fieldModel = new BackboneModel();
                                    fieldModel.set("values", collectionArray[i]);
                                    backboneCollection.add(fieldModel);
                                }
                            }

                        } else {
                            childObject = layoutModel.model.childView;
                            backboneCollection = getBackboneCollection( updatedCollection[ key ] );
                        }
                        displayItemsLayout( childObject, layoutModel, backboneCollection, defaultLayout, key, level );
                    }
                }
            }
        }
    }

}

/**
 * Render a collection of item fields into a layout
 * @param childObject {object} - child view model
 * @param layoutModel {object} - region view model
 * @param backboneCollection {Backbone.Collection} - collection of Backbone models to render
 * @param defaultLayout  {object} - instance of Backbone.Marionette.LayoutView
 * @param regionName {string} - region name where items will be displayed
 * @param level {number} - level of the nested properties (top level is 0)
 */
function displayItemsLayout( childObject, layoutModel, backboneCollection, defaultLayout, regionName, level ) {

    var childView,
        model,
        LayoutView,
        parentModel,
        regionLayout,
        regionKey;

    if ( childObject && layoutModel && backboneCollection && defaultLayout ) {

        childView = createBackboneChildView( childObject );
        model = layoutModel.model;
        if ( model && childView ) {

            LayoutView = Backbone.Marionette[ model.viewType ].extend({
                template: model.template,
                childView: childView,
                model: BackboneModel,
                childViewContainer: model.childViewContainer
            });

            if ( regionName ) {

                regionKey = regionName.replace("-body", "-primitive");
                if ( backboneCollection.models && backboneCollection.models.length > 0 ) {
                    // render the collection in the layout
                    parentModel = new BackboneModel;
                    regionLayout = new LayoutView( { collection: backboneCollection, model: parentModel } );
                }
                else {
                    // Show empty view
                    var bbModel = new BackboneModel;
                    bbModel.set("level", level);
                    regionLayout = new EmptyCollectionView( { model: bbModel } );
                }

                // Check that the region element exists in the region layout and the DOM
                if ( regionLayout && defaultLayout.getRegion( regionKey ) && $( defaultLayout.getRegion( regionKey ).el ).length > 0 ) {

                    defaultLayout.getRegion( regionKey ).empty();
                    defaultLayout.getRegion( regionKey ).show( regionLayout );
                }
            }
        }
    }
}

/**
 * Add values to the collection of field objects if they exist in the response object
 * @param jsonModel {object} - {object} - data JSON model
 * @param collection {object} - object with key as the nested field name and value as an array of nested field properties
 * @param response {object}  - ES response object
 * @param level {number} - level of the nested properties (top level is 0)
 * @returns {{}}
 */
function updateCollectionWithValues( jsonModel, collection, response, level ) {

    var updatedCollection = {},
        key,
        value;

    if ( collection && response ) {
        for ( key in collection ) {
            if ( collection.hasOwnProperty( key )) {
                // retrieve values from the response given the level of how deep the item is nested
                value = addObjectValues( jsonModel, collection, response, level );
                updatedCollection[ key ] = value;
            }
        }
    }

    return updatedCollection;
}

/**
 * Iterate through the response object and retrieve the key value
 * @param jsonModel {object} - data JSON model
 * @param collection {object} - object with key as the nested field name and value as an array of nested field properties
 * @param object {object}  - ES response object
 * @param level {number} - level of the nested properties (top level is 0)
 * @returns {*}
 */
function addObjectValues( jsonModel, collection, object, level ) {

    var itemsName,
        items,
        updatedItems = [],
        source,
        fieldKey,
        sourceObject,
        model,
        item,
        value,
        enumValue,
        i;

    for ( itemsName in collection ) {
        if ( collection.hasOwnProperty( itemsName )) {

            items = collection[ itemsName ];

            if ( items && hasKeys( object ) ) {

                source = object[ "_source" ];
                fieldKey = itemsName.replace("-body", "");
                sourceObject = getFieldObjectValues( fieldKey, source, level, jsonModel );
                model = getFieldModel( fieldKey, jsonModel, level, source );

                if ( hasKeys( model ) && model.type === "object" ) {

                    if ( model.multiple && model.multiple.toString() === "true" ) {
                        // array of objects
                        updatedItems = getUpdatedArray( sourceObject, items );
                        // update link items without values
                        updatedItems = updateLinkItems( updatedItems, object, model, jsonModel );
                    }
                    else {
                        // nested object
                        for ( i = 0; i < items.length; i++ ) {
                            item = items[ i ];

                            if ( item ) {

                                if ( sourceObject ) {
                                    value = sourceObject[ item.name ];
                                }
                                if ( value ) {
                                    // make an array if marked multiple, but single
                                    // primitive value is returned
                                    if ( item.multiple && item.multiple.toString() === "true" ) {
                                        if ( value.constructor !== Array ) {
                                            value = [ value ];
                                        }
                                    }
                                    // retrieve an item value if item is of type enumeration
                                    if ( item.type === "enumeration" && item.options && hasKeys( item.options )) {
                                        enumValue = item.options[ value ];
                                        // if option with that value could not be found, revert the value to the source value
                                        if ( ! enumValue ) {
                                            value = sourceObject[ item.name ];
                                        } else {
                                            value = enumValue;
                                        }
                                    }
                                    item.value = value;
                                    if ( item.value ) {
                                        updatedItems.push( item );
                                    }
                                }
                                else {

                                    // TODO (no current use-cases)
                                    // check if item is a link
                                    // if item is a link with no value, construct the value from the base_url attribute of the parent
                                    // Add item to the array

                                    if ( item.is_link ) {
                                        // console.log( "Update link item without value" );
                                        // console.log( item );
                                    }
                                }
                            }

                        }
                    }
                }
            }
        }
    }

    return updatedItems;
}

/**
 * Add values to the items inside an array of objects
 * @param sourceObject {object} - ES response _source object
 * @param items [{object}] - array of field objects
 * @returns {Array} - array of field objects with values
 */
function getUpdatedArray( sourceObject, items  ) {
    var itemsArray = [],
        valueObject,
        value,
        j,
        k;

    if ( sourceObject ) {
        for ( k = 0; k < sourceObject.length; k++ ) {
            valueObject = sourceObject[k];
            // Check if the object inside valueObject itself is an array
            if ( valueObject && valueObject.constructor === Array ) {
                // get the object inside the array
                var valueObjectArray = JSON.parse( JSON.stringify( valueObject ) );

                for ( j = 0; j < valueObjectArray.length; j++ ) {
                    valueObject = valueObjectArray[ j ];
                    value = getItemsArray(valueObject, items);
                    if ( value ) {
                        itemsArray.push( value );
                    }

                }

            } else {
                value = getItemsArray( valueObject, items );
                if ( value ) {
                    itemsArray.push( value );
                }

            }

        }
    }

    return itemsArray;
}

/**
 * Construct items array with values
 * @param valueObject {object} - data object for the item to show
 * @param items {Array} - array of item models
 * @returns {Array}
 */
function getItemsArray( valueObject, items ) {

    var fieldName,
        value,
        i,
        itemObject,
        itemKey,
        itemsArray = [];

    for ( fieldName in valueObject ) {
        if ( valueObject.hasOwnProperty( fieldName ) ) {
            for ( i = 0; i < items.length; i++ ) {
                if ( items[ i ].name === fieldName ) {
                    value = valueObject[ fieldName ];
                    if ( items[ i ].multiple && items[ i ].multiple.toString() === "true" ) {
                        if ( value.constructor !== Array ) {
                            value = [ value ];
                        }
                    }
                    if ( value ) {
                        // make a copy of the item
                        itemObject = {};

                        for ( itemKey in items[i] ) {
                            if ( items[i].hasOwnProperty( itemKey ) ) {
                                itemObject[ itemKey ] = items[i][ itemKey ];
                            }
                        }

                        itemObject[ "value" ] = value;
                        itemsArray.push(itemObject);
                    }
                }
            }
        }
    }
    return itemsArray;
}

/**
 * Find the number of keys inside of a deeply nested object
 * @param object {object} - any JavaScript object with key-value pairs
 * @returns {number}
 */
function getNumberOfObjects( object ) {

    var total = 0,
        key;
    if ( hasKeys( object )) {
        for ( key in object ) {
            if ( object.hasOwnProperty( key )) {
                total++;
                if ( typeof object[key] === "object" ) {
                    total += getNumberOfObjects( object[key] );
                }
            }
        }
    }
    return total;
}

/**
 * Find an object in the source object corresponding to the key
 * @param fieldKey {string} - field key name
 * @param source {object} - source data object
 * @param level {number} - an integer between 0 and n of how far from the top the field is
 * @param jsonModel {object} - JSON data model
 * @returns {{}}
 */
function getFieldObjectValues( fieldKey, source, level, jsonModel ) {
    var sourceObject = {},
        sources = {},
        objectsSeen = 0, // keep track of how many objects have been seen
        total,
        sourceKey,
        field,
        i;

    if ( level === 0 ) {  // level = 0 is the top panel that contains fields on the first level of source
        sourceObject = source;
    }

    var levelObjects = {};
    if ( level > 1 ) {

        // get nested objects from source using level and JSON data model
       levelObjects = getLevelObjects(level, source, jsonModel);

        if ( hasKeys( levelObjects )) {
            sourceObject = levelObjects[ fieldKey ];
        }
    } else {
        if ( hasKeys( source )) {

            //total number of keys in a nested object
            total = getNumberOfObjects( source );

            // Find all fields that are inside the _source object (level 0), which is level 1
            for ( i = 1; i <= level; i++ ) {
                // Keep track of how many objects have been seen so far as another way to prevent infinite loop
                if ( objectsSeen <= total ) {
                    for ( sourceKey in source )  {
                        if ( hasKeys( source ) && source.hasOwnProperty( sourceKey )) {

                            // find the nested field
                            field =  source[ sourceKey ];

                            if ( typeof field === "object" && ! ( sourceKey === "ACL_ALLOW" || sourceKey === "ACL_DENY" )) {
                                if ( i === level ) {
                                    // store the nested object in the sources object
                                    sources[ sourceKey ] = source[ sourceKey ];
                                } else {
                                    source = source[ sourceKey ];
                                }
                            }
                            objectsSeen++;
                        }
                    }
                } else {
                    // break out of the loop if all objects have been seen
                    break;
                }

            }

            if ( hasKeys( sources )) {
                sourceObject = sources[ fieldKey ];
            }
        }
    }

    return sourceObject;
}

/**
 * Get source objects on a specified level. Level 0 is the fields inside the _source object
 * @param level {number} - level number, starting at 0
 * @param source {object} - source object
 * @param jsonModel {object} - data JSON model
 * @returns {object}
 */
function getLevelObjects( level, source, jsonModel ) {
    var levelObjects = {};
    var level1Objects = getFirstLevelObjects(source);
    var level1Models = getFirstLevelModels(jsonModel);

    // Look at each property object inside each level 1 model and save those that are objects themselves
    if ( level === 1 ) {
        levelObjects = level1Objects;
    } else if ( level > 1 ) {
        levelObjects = getLevelObjectsFromParent(level, level1Models, level1Objects);
    }

    return levelObjects;
}

/**
 * Get objects on a specified level from an array of parent objects
 * @param level {number} - level number, starting at 0
 * @param parentModels {Array} - array of parent data models
 * @param parentObjects {object} - object containing parent source objects
 * @returns {{}}
 */
function getLevelObjectsFromParent( level, parentModels, parentObjects) {
    var levelObjects = {},
        model,
        props,
        prop,
        parentProperty,
        i;

    if ( level > 0 ) {
        for ( i = 0; i < parentModels.length; i++ ) {
            model = parentModels[ i ];
            if ( model ) {
                props = model.properties;
                if ( props ) {
                    for ( prop = 0; prop < props.length; prop++ ) {
                        parentProperty = props[ prop ];
                        if ( parentProperty && parentProperty.type === "object") {
                            // find nested objects inside a parent-level object
                            levelObjects = findNestedObjects( parentObjects, model, parentProperty, levelObjects );
                        }
                    }
                }
            }
        }
    }

    return levelObjects;
}

/**
 * Get nested objects from an array of parent nested objects
 * @param parentObjects {object} - object containing parent source objects
 * @param model {object} - data model of one nested parent model
 * @param parentProperty {object} - data model of one nested property item
 * @param levelObjects {Array} - cumulative array of level objects
 * @returns {*}
 */
function findNestedObjects( parentObjects, model, parentProperty, levelObjects ) {
    var parentObjectName,
        parentObject,
        name,
        i;

    for ( parentObjectName in parentObjects ) {
        if ( parentObjects.hasOwnProperty( parentObjectName ) ) {
            parentObject = parentObjects[ parentObjectName ];
            if ( parentObject && parentObjectName === model.name ) {
                name = parentProperty.name;
                if ( name ) {
                    if ( parentProperty.multiple === "true" ) {
                        // iterate over an array of objects
                        levelObjects[ name ] = [];
                        for ( i = 0; i < parentObject.length; i++ ) {
                            levelObjects[ name ][ i ] = parentObject[ i ][ name ];
                        }
                    }
                    else {
                        levelObjects[ name ] = parentObject[ name ];
                    }

                }
            }
        }
    }
    return levelObjects;
}

/**
 * Get all non-primitive objects from the _source object on the first level
 * @param source {object} - record _source object
 * @returns {object}
 */
function getFirstLevelObjects( source ) {
    var level1Objects = {},
        key,
        value;

    for ( key in source ) {
        if ( source.hasOwnProperty( key )) {
            value = source[ key ];
            if ( value && typeof value === "object" ) {
                // store nested objects into an object
                level1Objects[ key ] = value;
            }
        }
    }

    return level1Objects;
}

/**
 * Get all non-primitive models from the JSON data model on the first level
 * @param jsonModel {object} - JSON data model
 * @returns {Array}
 */
function getFirstLevelModels( jsonModel ) {
    var level1Models = [],
        properties,
        property,
        i;

    if ( jsonModel ) {
        properties = jsonModel.properties;
        if ( properties ) {
            for ( i = 0; i < properties.length; i++ ) {
                property = properties[ i ];
                if ( property && property.type === "object" ) {
                    // store nested models into an array
                    level1Models.push( property );
                }
            }
        }
    }
    return level1Models;
}

/**
 * Get source model for a nested field
 * @param parentModels {Array} - array of parent source models
 * @param fieldKey {string} - name of the field
 * @returns {object}
 */
function getLevelSourceModel( parentModels, fieldKey ) {
    var sourceModel = {},
        model,
        props,
        prop,
        childProperty,
        l;

    for ( l = 0; l < parentModels.length; l++ ) {
        model = parentModels[l];
        if ( model ) {
            props = model.properties;
            if (props) {
                for ( prop = 0; prop < props.length; prop++ ) {
                    childProperty = props[ prop ];
                    if ( childProperty && childProperty.type === "object") {
                        if ( childProperty.name === fieldKey ) {
                            sourceModel = childProperty;
                        }
                    }
                }
            }
        }
    }
    return sourceModel;
}

/**
 * Get the field model which is a part of the data model
 * @param fieldKey {string} - field key name
 * @param jsonModel {object} - data JSON model
 * @param level {number} - an integer between 0 and n of how far from the top the field model is
 * @param source {object} - source data object
 * @returns {*}
 */
function getFieldModel( fieldKey, jsonModel, level, source ) {
    var sourceModel,
        objectsSeen = 0, // keep track of how many objects have been seen
        models,
        model,
        totalInSource,
        totalInModel,
        total,
        i,
        j;

    if ( source && jsonModel ) {
        totalInSource = getNumberOfObjects( source );
        totalInModel = getNumberOfObjects( jsonModel );
        total = Math.max( totalInSource, totalInModel );

        if ( jsonModel.properties ) {

            models = jsonModel.properties; // make a copy of the model

            if ( level === 0 ) {  // level = 0 is the top panel that contains fields on the first level of source
                sourceModel = { "type": "object" };
            }

            
            // find field model at the given level
            if ( level > 1 ) {
                var level1Models = getFirstLevelModels(jsonModel);
                sourceModel = getLevelSourceModel( level1Models, fieldKey );

            } else {
                i = 1;
                while ( i <= level && objectsSeen <= total ) {
                    if ( models && models.length ) {
                        for ( j = 0; j < models.length; j++ )  {
                            model = models[j];
                            // find the nested field
                            if ( model && model.type === "object" ) {

                                if ( i === level ) {
                                    // store the nested object in the sources array
                                    if ( model.name === fieldKey ) {
                                        sourceModel = model;
                                        i++;
                                    }
                                } else {
                                    models = model.properties;
                                    if ( models ) {
                                        j = 0;
                                        i++;
                                    } else {
                                        // do something if object does not have properties?
                                        // models = model;
                                        models = [];
                                    }

                                }
                            }
                            objectsSeen++;
                        }
                    }
                }
            }

        }
    }
    return sourceModel;
}